export class Navbar {
    private static readonly threshold: number = 0;

    private readonly navbar: HTMLElement;
    private readonly navbarContent: HTMLElement;
    private readonly navbarItems: HTMLElement[];

    private canBeTransparent = false;
    private navbarContentShown = false;
    private navbarToggle: HTMLElement;
    private navbarToggleCaption: HTMLElement;
    private navbarToggleIcon: HTMLElement;

    public constructor() {
        this.navbar = document.querySelector('#navbar') as HTMLElement;
        this.navbarToggle = document.querySelector('.navbar-toggle') as HTMLElement;
        this.navbarToggleCaption = document.querySelector('.navbar-toggle-caption') as HTMLElement;
        this.navbarToggleIcon = document.querySelector('.navbar-toggle-icon') as HTMLElement;
        this.navbarContent = document.querySelector('.navbar-content') as HTMLElement;
        this.navbarItems = [ ...document.querySelectorAll<HTMLElement>('.navbar-content a') ];

        this.toggleNavbarBackground();
    }

    public register(): void {
        this.navbarToggle.onclick = this.toggleNavbarContent.bind(this);
        this.navbarItems.forEach((navbarItem): void => {
            /* eslint-disable no-param-reassign */
            navbarItem.onclick = this.hideNavbarContentOnNavigation.bind(this);
            /* eslint-enable no-param-reassign */
        });
        document.onscroll = this.toggleNavbarBackground.bind(this);
    }

    public toggleNavbarContent(event: MouseEvent): void {
        event.preventDefault();

        if (!this.navbarContentShown) {
            this.showNavbarContent();
        } else {
            this.hideNavbarContent();
        }
    }

    public hideNavbarContentOnNavigation(): void {
        this.hideNavbarContent();
    }

    private showNavbarContent(): void {
        this.navbarContentShown = true;
        this.navbarContent.classList.add('is-shown');
        this.navbarToggleCaption.innerText = 'Close menu';
        this.navbarToggleIcon.innerHTML = '<i class="fas fa-times fa-fw"></i>';
        this.toggleNavbarBackground();
    }

    private hideNavbarContent(): void {
        this.navbarContentShown = false;
        this.navbarContent.classList.remove('is-shown');
        this.navbarToggleCaption.innerText = 'Open menu';
        this.navbarToggleIcon.innerHTML = '<i class="fas fa-bars fa-fw"></i>';
        this.toggleNavbarBackground();
    }

    private toggleNavbarBackground(): void {
        if (this.navbar.classList.contains('is-transparent') && !this.canBeTransparent) {
            this.canBeTransparent = true;
        }

        if (!this.canBeTransparent) {
            return;
        }

        if (window.scrollY <= Navbar.threshold && !this.navbarContentShown) {
            this.navbar.classList.add('is-transparent');
        } else {
            this.navbar.classList.remove('is-transparent');
        }
    }
}
